module.exports = __webpack_public_path__ + "static/img/review-propile-none.49da6b4e.svg";